export default __webpack_public_path__ + "static/media/dropdown-up-arrow.0f0e75a8.svg";